import Tracker from './Tracker';
import { labelEvents } from './FileBrowser';

const MailCampaignTracker = new Tracker('MailCampaign', {
	...labelEvents,
	CREATED: 'created'
});

export default MailCampaignTracker;
